import Global from './lib/global';

Global();